import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles<Theme>(theme => ({
  root: {
    width: 850,
    backgroundColor: '#fff',
    borderRadius: 12,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 25px)',
      marginTop: 30
    }
  },
  paragraphQuestion: {
    borderRadius: 0,
    backgroundColor: '#1E5593',
    minHeight: 220,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      borderRadius: '12px 12px 0 0'
    }
  },
  paragraphContainer: {
    color: '#fff',
    fontSize: 26,
    lineHeight: '35px',
    padding: '0 50px',
    flex: '1',
    '&:hover': {
      cursor: 'pointer'
    },
    '&  *': {
      display: 'inline'
    },
    '& p': {
      padding: 0,
      fontWeight: 500,
      color: theme.palette.common.lightOrange,
      margin: '0 5px 0 0'
    },
    [`& > *:nth-of-type(2n + 1) p`]: {
      color: theme.palette.common.lightBlue
    },
    [`& > *:last-of-type p`]: {
      margin: 0
    },
    [theme.breakpoints.down('xs')]: {
      padding: 30,
      '&  p': {
        fontSize: 18
      }
    }
  },
  freeTextRoot: {
    display: 'inline',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  inputContainer: {
    flex: 2,
    '&  p': {
      fontWeight: 500,
      '&:hover': {
        background: 'none'
      }
    },
    '& .MuiInputBase-root': {
      borderRadius: 10
    },
    '& .MuiTypography-root': {
      fontSize: 18
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: 15,
      width: '100%'
    }
  },
  labelContainer: {
    flex: 1,
    textAlign: 'right',
    justifyContent: 'flex-end',
    display: 'inline',
    [theme.breakpoints.down('xs')]: {
      marginBottom: 5,
      width: '100%'
    },
    '& .MuiFormLabel-root': {
      color: '#fff',
      marginRight: 6,
      fontSize: 18
    }
  },
  questionContainerDisabled: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: '20px 0',
    transition: 'all 0.3s ease',
    cursor: 'cursor',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 30
    }
  },
  questionsContainer: {
    padding: '0 50px'
  },
  detailBox: {
    paddingLeft: 50,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0
    }
  },
  detailInputContainer: {
    width: '100%',
    '&  p': {
      fontWeight: 300,
      lineHeight: '40px',
      color: theme.palette.common.darkGrey
    },
    '& .MuiInputBase-root': {
      backgroundColor: '#fff'
    },
    [theme.breakpoints.down('xs')]: {
      '&  p': {
        fontSize: 12,
        lineHeight: '20px'
      }
    }
  },
  freeTextDetailRoot: {
    display: 'flex'
  },
  titleInputContainer: {
    marginBottom: 0,
    '&  p': {
      fontSize: 24,
      fontWeight: 500
    },
    [theme.breakpoints.down('xs')]: {
      '&  p': {
        fontSize: 18,
        paddingTop: 0
      }
    }
  },
  bottomRounded: {
    borderRadius: '0 0 12px 12px'
  }
}))
